import { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import {
  cardSx,
  smallBoxSx,
  titleBoxSx,
  titleSx,
  starIconButtonSx,
  starBorder,
  descriptionSx,
  cardAction,
} from './styles';

export interface CentralReportsCardProps {
  description?: string;
  title: string;
  url: string;
}

export default function CentralReportsCard({ description, title, url }: CentralReportsCardProps) {
  const [favorite, setFavorite] = useState(false);
  const { t } = useTranslation();

  return (
    <Card sx={cardSx}>
      <CardActionArea href={url} sx={cardAction}>
        <Box sx={smallBoxSx}>
          <Box sx={titleBoxSx}>
            <Typography sx={titleSx} color='text.primary'>
              {title}
            </Typography>
            <IconButton
              aria-label={t('admin.centralReportsPage.productMixDescription')}
              size='small'
              sx={starIconButtonSx}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setFavorite((fav) => !fav);
              }}
            >
              {favorite ? <StarIcon /> : <StarBorderIcon sx={starBorder} />}
            </IconButton>
          </Box>
          <Typography sx={descriptionSx} color='text.secondary'>
            {description}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
}

CentralReportsCard.defaultProps = {
  description: undefined,
};
